import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::deleteMethod
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
export const deleteMethod = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/payment-mode/{payment_mode}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::deleteMethod
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
deleteMethod.url = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_mode: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment_mode: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment_mode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_mode: typeof args.payment_mode === 'object'
        ? args.payment_mode.id
        : args.payment_mode,
    }

    return deleteMethod.definition.url
            .replace('{payment_mode}', parsedArgs.payment_mode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::deleteMethod
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}'
*/
deleteMethod.delete = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::undo
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}/undo-delete'
*/
export const undo = (args: { payment_mode: string | number } | [payment_mode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/payment-mode/{payment_mode}/undo-delete',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::undo
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}/undo-delete'
*/
undo.url = (args: { payment_mode: string | number } | [payment_mode: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_mode: args }
    }

    if (Array.isArray(args)) {
        args = {
            payment_mode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_mode: args.payment_mode,
    }

    return undo.definition.url
            .replace('{payment_mode}', parsedArgs.payment_mode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::undo
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}/undo-delete'
*/
undo.get = (args: { payment_mode: string | number } | [payment_mode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaymentMode\DeletePaymentModeController::undo
* @see app/Http/Controllers/PaymentMode/DeletePaymentModeController.php
* @route '/api/payment-mode/{payment_mode}/undo-delete'
*/
undo.head = (args: { payment_mode: string | number } | [payment_mode: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeletePaymentModeController = { deleteMethod, undo, delete: deleteMethod }

export default DeletePaymentModeController